import logo from '../images/st_w2.jpg';

const Logo = () => {
	return (

			<img src={logo} alt="logo" className='border-solid border-4 border-dark-yellow rounded-xl' />
	);
}
 
export default Logo;